import React from 'react';
import { Route } from 'react-router';
import RoutePrivate from './pages/components/Authentication/RoutePrivate';
import Notifications from './pages/components/Notifications';
import SwitchConnected from './pages/components/utilities/router/SwitchConnected';
import ScrollToTop from './pages/components/utilities/router/ScrollToTop';
import PageAuthentication from './pages/PageAuthentication';
import PageWelcome from './pages/PageWelcome';
import WorkspaceEvent from './pages/WorkspaceEvent';
import PageErrorNotFound from './pages/PageErrorNotFound';
import PageKitchen from './pages/PageKitchen';
var Routes = function () { return (React.createElement(React.Fragment, null,
    React.createElement(ScrollToTop, null),
    React.createElement(Notifications, null),
    React.createElement(SwitchConnected, null,
        React.createElement(Route, { path: '/', exact: true, component: PageAuthentication }),
        React.createElement(Route, { path: '/login', component: PageAuthentication }),
        React.createElement(RoutePrivate, { path: '/welcome', component: PageWelcome }),
        React.createElement(RoutePrivate, { path: '/event/:subdomain', component: WorkspaceEvent }),
        process.env.NODE_ENV === 'development' &&
            React.createElement(Route, { path: '/dev/kitchen-sink', component: PageKitchen }),
        React.createElement(Route, { component: PageErrorNotFound })))); };
export default Routes;



//////////////////
// WEBPACK FOOTER
// ./src/routes.tsx
// module id = 652
// module chunks = 0